import UserModelBase from '../_generated/modelBases/user-model-base';

export default class UserModel extends UserModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
